import { Box, Grid } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import ImageCustom from 'commons/ImageCustom';
import Text from 'commons/Text';
import API from 'configs/API';

import HistoricalImageLightBox from '../HistoricalImageLightBox';
import useStyles from './styles';

const MAX_VISIBLE_IMAGES = 4;

const HistoricalImages = ({ artworkId }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [isLightBoxOpen, setIsLightBoxOpen] = useState(false);

  const {
    data: historicalImages = [],
    isPending,
    isError,
  } = useQuery({
    queryKey: [API.ARTWORK.HISTORICAL_IMAGES(artworkId)],
    enabled: !!artworkId,
  });

  const handleClickImage = (index) => {
    setSelectedImageIndex(index);
    setIsLightBoxOpen(true);
  };

  const handleCloseLightBox = () => {
    setIsLightBoxOpen(false);
  };

  if (isPending || isError || !historicalImages?.length) {
    return null;
  }

  const visibleImages = historicalImages.slice(0, MAX_VISIBLE_IMAGES);
  const remainingCount = historicalImages.length - MAX_VISIBLE_IMAGES;

  return (
    <Box className={classes.wrapBox}>
      <Text
        fontWeightBold
        type="xl"
      >
        {t('historical_images')}
      </Text>
      <div className={classes.wrapListImages}>
        <Grid
          container
          spacing={3}
        >
          {visibleImages.map((item, index) => {
            const isLastImage = index === MAX_VISIBLE_IMAGES - 1;
            const shouldShowOverlay = isLastImage && remainingCount > 0;

            return (
              <Grid
                key={item?.id}
                item
                xs={12}
                lg={3}
              >
                <Box
                  className={classes.imageWrapper}
                  onClick={() => handleClickImage(index)}
                >
                  <ImageCustom
                    src={item?.image}
                    imageStyle={classes.image}
                    loadingStyle={classes.imageLoading}
                  />
                  {shouldShowOverlay && (
                    <Box className={classes.overlay}>
                      <Text className={classes.overlayText}>+{remainingCount}</Text>
                    </Box>
                  )}
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </div>

      <HistoricalImageLightBox
        open={isLightBoxOpen}
        onClose={handleCloseLightBox}
        images={historicalImages}
        initialIndex={selectedImageIndex}
      />
    </Box>
  );
};

export default HistoricalImages;
